// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__fmnWz","col":"styles_col__3r9of"};